export const SUBJECT = 1;
export const COPY = 2;

export default {
  SUBJECT,
  COPY
};
